import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import * as actions from '../../actions/orderActions'
import {
    getCurrentGroupOrder,
    getRestaurantSettings,
} from '../../selectors'
import { calcMoneyFood, checkTimeCanAddFood } from '../../utils'

import { Modal } from 'antd-mobile'
import useMoney from '../../hooks/useMoney'
import { ensureArray } from '../../utils/helper'
import useFood from '../../hooks/useFood'
import useOrder from '../../hooks/useOrder'
const alert = Modal.alert

const HOCFoodDetails = ({
    foodDetails,
    goBack,
    FoodComponent,
    formGroupFood,
    onClose,
    isModal,
    foodSubs,
    handleChangeFoodShow,
    foodParent,
    foodShowIndex,
}) => {
    const { in_vat = 0, happy_hours_settings } = useSelector(
        getRestaurantSettings
    )
    const cart = useSelector(state => state.OrderReducer.ordering)
    const currentGroupOrder = useSelector(getCurrentGroupOrder)
    const validTimeAddFood = foodDetails ? checkTimeCanAddFood(foodDetails) : false
    const dispatch = useDispatch()
    const { t } = useTranslation()

    const { isFoodSoldOut } = useFood(foodDetails);
    const { addToCart } = useOrder();

    const [formData, setFormData] = useState({
        amount: 1,
        note: '',
        beilageItems: [],
        index: -1,
    })

    const money = useMoney(calcMoneyFood, {
        foodDetails,
        ...formData,
    })

    const handleChange = (name, value) => {
        if (name === 'amount' && value < 1) {
            return
        }
        setFormData(oldData => ({
            ...oldData,
            [name]: value,
        }))
    }

    const handleChangeTopping = (indexGroup, indexTopping) => {
        let newData = { ...formData }
        if (newData.beilageItems[indexGroup]) {
            let groupTopping = [...newData.beilageItems[indexGroup]]
            const { type } = foodDetails?.beilageItems[indexGroup]
            const hasChecked = groupTopping[indexTopping]

            type !== 1 && (groupTopping = [])
            groupTopping[indexTopping] = !hasChecked

            newData.beilageItems[indexGroup] = groupTopping
        } else {
            let rs = []
            rs[indexTopping] = true
            newData.beilageItems[indexGroup] = rs
        }
        setFormData(newData)
    }

    const addGroup = arrID => {
        dispatch(
            actions.addFoodGroupToCart({
                params: {
                    arrID,
                    vat: in_vat,
                    ...formData,
                },
                onDone: success => {
                    success && goBack && goBack()
                    // if (!errorMessage) {
                    //     goBack && goBack()
                    // }
                },
            })
        )
    }

    const handleSubmit = () => {
        if (foodDetails?.pluGroup) {
            addGroup(foodDetails?.pluGroup.split(';').filter(el => !!el))
        } else {
            const beilageItems = ensureArray(foodDetails?.beilageItems)
            for (let i = 0; i < beilageItems.length; i++) {
                if (
                    beilageItems[i].option &&
                    (!formData.beilageItems[i] ||
                        formData.beilageItems[i].every(el => !el))
                ) {
                    alert(
                        '',
                        t('message.beilageRequire', {
                            group: beilageItems[i].group_name,
                        }),
                        [{ text: 'Ok', onPress: () => console.log('ok') }]
                    )

                    if (isModal) {
                        const el = document.querySelector('.food-details-modal')
                        const elmnt = document.getElementById(`beilage-${i}`)
                        el && elmnt && (el.scrollTop = elmnt.offsetTop)
                    }
                    return
                }
            }
            const { currentPrice, saleOfPercent, isHappyHour } = money;

            addToCart({
                ...formData,
                foodDetails: {
                    ...foodDetails,
                    currentPrice:
                        foodDetails?.currentPrice ?? currentPrice,
                    saleOfPercent,
                    foodParent: foodDetails.foodParent || foodParent,
                },
                isHappyHour,
                vat: in_vat,
                groupOrder: currentGroupOrder
            });

            goBack && goBack();
        }
    }

    useEffect(() => {
        let newForm = {
            amount: 1,
            note: '',
            index: -1,
            ...formGroupFood,
            beilageItems: [],
        }

        if (foodDetails) {
            let { index } = foodDetails

            if (index === undefined) {
                const { currentPrice } = money

                index = cart.findIndex(f => {
                    const { foodDetails: food, submitted } = f
                    return (
                        !submitted &&
                        currentGroupOrder === f.groupOrder &&
                        food?.id === foodDetails?.id &&
                        f.vat === in_vat &&
                        f.note === '' &&
                        f.beilageItems.length === 0 &&
                        f.foodDetails?.currentPrice === currentPrice
                    )
                })
            }

            if (index !== -1) {
                console.log(cart[index])
                const { amount, note, beilageItems, vat } = cart[index]
                newForm = {
                    ...newForm,
                    amount,
                    note,
                    beilageItems: JSON.parse(JSON.stringify(beilageItems)),
                    vat,
                    index,
                }
            }
        }

        setFormData(newForm)
    }, [cart, foodDetails, in_vat])

    return (
        <FoodComponent
            onClose={onClose}
            handleChange={handleChange}
            isUpdate={formData.index !== -1}
            handleSubmit={handleSubmit}
            money={money}
            handleChangeTopping={handleChangeTopping}
            formData={formData}
            goBack={goBack}
            food={foodDetails}
            isFoodDisabled={isFoodSoldOut}
            validTimeAddFood={validTimeAddFood}
            isOpen={!!foodDetails}
            happy_hours_settings={happy_hours_settings}
            foodSubs={foodSubs}
            handleChangeFoodShow={handleChangeFoodShow}
            foodParent={foodParent}
            foodShowIndex={foodShowIndex}
        />
    )
}

export default HOCFoodDetails
